// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-alert {
  display: grid;
  flex: 1 1;
  grid-template-areas: "prepend content append close" ". content . .";
  grid-template-columns: max-content auto max-content max-content;
  position: relative;
  padding: 16px;
  overflow: hidden;
  --v-border-color: currentColor;
}
:where(.vuetify-styles) .v-alert--absolute {
  position: absolute;
}
:where(.vuetify-styles) .v-alert--fixed {
  position: fixed;
}
:where(.vuetify-styles) .v-alert--sticky {
  position: sticky;
}
:where(.vuetify-styles) .v-alert {
  border-radius: 4px;
}
:where(.vuetify-styles) .v-alert--variant-plain, :where(.vuetify-styles) .v-alert--variant-outlined, :where(.vuetify-styles) .v-alert--variant-text, :where(.vuetify-styles) .v-alert--variant-tonal {
  background: transparent;
  color: inherit;
}
:where(.vuetify-styles) .v-alert--variant-plain {
  opacity: 0.62;
}
:where(.vuetify-styles) .v-alert--variant-plain:focus, :where(.vuetify-styles) .v-alert--variant-plain:hover {
  opacity: 1;
}
:where(.vuetify-styles) .v-alert--variant-plain .v-alert__overlay {
  display: none;
}
:where(.vuetify-styles) .v-alert--variant-elevated, :where(.vuetify-styles) .v-alert--variant-flat {
  background: rgb(var(--v-theme-surface-light));
  color: rgba(var(--v-theme-on-surface-light), var(--v-high-emphasis-opacity));
}
:where(.vuetify-styles) .v-alert--variant-elevated {
  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-alert--variant-flat {
  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));
}
:where(.vuetify-styles) .v-alert--variant-outlined {
  border: thin solid currentColor;
}
:where(.vuetify-styles) .v-alert--variant-text .v-alert__overlay {
  background: currentColor;
}
:where(.vuetify-styles) .v-alert--variant-tonal .v-alert__underlay {
  background: currentColor;
  opacity: var(--v-activated-opacity);
  border-radius: inherit;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
}
:where(.vuetify-styles) .v-alert .v-alert__underlay {
  position: absolute;
}
:where(.vuetify-styles) .v-alert--prominent {
  grid-template-areas: "prepend content append close" "prepend content . .";
}
:where(.vuetify-styles) .v-alert.v-alert--border {
  --v-border-opacity: 0.38;
}
:where(.vuetify-styles) .v-alert.v-alert--border.v-alert--border-start {
  padding-inline-start: 24px;
}
:where(.vuetify-styles) .v-alert.v-alert--border.v-alert--border-end {
  padding-inline-end: 24px;
}
:where(.vuetify-styles) .v-alert--variant-plain {
  transition: 0.2s opacity cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-alert--density-default {
  padding-bottom: 16px;
  padding-top: 16px;
}
:where(.vuetify-styles) .v-alert--density-default.v-alert--border-top {
  padding-top: 24px;
}
:where(.vuetify-styles) .v-alert--density-default.v-alert--border-bottom {
  padding-bottom: 24px;
}

:where(.vuetify-styles) .v-alert--density-comfortable {
  padding-bottom: 12px;
  padding-top: 12px;
}
:where(.vuetify-styles) .v-alert--density-comfortable.v-alert--border-top {
  padding-top: 20px;
}
:where(.vuetify-styles) .v-alert--density-comfortable.v-alert--border-bottom {
  padding-bottom: 20px;
}

:where(.vuetify-styles) .v-alert--density-compact {
  padding-bottom: 8px;
  padding-top: 8px;
}
:where(.vuetify-styles) .v-alert--density-compact.v-alert--border-top {
  padding-top: 16px;
}
:where(.vuetify-styles) .v-alert--density-compact.v-alert--border-bottom {
  padding-bottom: 16px;
}

:where(.vuetify-styles) .v-alert:not(:has(.v-alert-title)) .v-alert__content {
  padding-block: calc((1.75rem - 1.5 * 1rem) / 2);
}

:where(.vuetify-styles) .v-alert__border {
  border-radius: inherit;
  bottom: 0;
  left: 0;
  opacity: var(--v-border-opacity);
  position: absolute;
  pointer-events: none;
  right: 0;
  top: 0;
  width: 100%;
}
:where(.vuetify-styles) .v-alert__border {
  border-color: currentColor;
  border-style: solid;
  border-width: 0;
}
:where(.vuetify-styles) .v-alert__border--border {
  border-width: 8px;
  box-shadow: none;
}
:where(.vuetify-styles) .v-alert--border-start .v-alert__border {
  border-inline-start-width: 8px;
}
:where(.vuetify-styles) .v-alert--border-end .v-alert__border {
  border-inline-end-width: 8px;
}
:where(.vuetify-styles) .v-alert--border-top .v-alert__border {
  border-top-width: 8px;
}
:where(.vuetify-styles) .v-alert--border-bottom .v-alert__border {
  border-bottom-width: 8px;
}

:where(.vuetify-styles) .v-alert__close {
  flex: 0 1 auto;
  grid-area: close;
}
:where(.vuetify-styles) .v-alert__close > .v-btn {
  margin-block: calc(-1 * (var(--v-btn-height) + 12px - 1.75rem) / 2);
}

:where(.vuetify-styles) .v-alert__content {
  align-self: center;
  grid-area: content;
  overflow: hidden;
}

:where(.vuetify-styles) .v-alert__append,
:where(.vuetify-styles) .v-alert__close {
  margin-inline-start: 16px;
}

:where(.vuetify-styles) .v-alert__append {
  align-self: flex-start;
  grid-area: append;
}
:where(.vuetify-styles) .v-alert__append + .v-alert__close {
  margin-inline-start: 16px;
}

:where(.vuetify-styles) .v-alert__prepend {
  align-self: flex-start;
  display: flex;
  align-items: center;
  grid-area: prepend;
  margin-inline-end: 16px;
  min-height: 1.75rem;
}
:where(.vuetify-styles) .v-alert__prepend > .v-icon {
  font-size: 1.75rem;
  height: 1.75rem;
  width: 1.75rem;
}
:where(.vuetify-styles) .v-alert--prominent .v-alert__prepend {
  align-self: center;
}

:where(.vuetify-styles) .v-alert__underlay {
  grid-area: none;
  position: absolute;
}
:where(.vuetify-styles) .v-alert--border-start .v-alert__underlay {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
:where(.vuetify-styles) .v-alert--border-end .v-alert__underlay {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
:where(.vuetify-styles) .v-alert--border-top .v-alert__underlay {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
:where(.vuetify-styles) .v-alert--border-bottom .v-alert__underlay {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

:where(.vuetify-styles) .v-alert-title {
  align-items: center;
  align-self: center;
  display: flex;
  font-size: 1.25rem;
  font-weight: 500;
  hyphens: auto;
  letter-spacing: 0.0125em;
  line-height: 1.75rem;
  overflow-wrap: normal;
  text-transform: none;
  word-break: normal;
  word-wrap: break-word;
}

@media (forced-colors: active) {
  :where(.vuetify-styles) .v-alert:not(.v-alert--variant-text, .v-alert--variant-plain) {
    border-style: solid;
  }
  :where(.vuetify-styles) .v-alert--variant-outlined, :where(.vuetify-styles) .v-alert--variant-tonal {
    border-width: medium;
  }
  :where(.vuetify-styles) .v-alert--variant-elevated, :where(.vuetify-styles) .v-alert--variant-flat {
    border-width: thick;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VAlert/VAlert.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mEAAmE;EACnE,+DAA+D;EAC/D,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,6CAA6C;EAC7C,4EAA4E;AAC9E;AACA;EACE,uOAAuO;AACzO;AACA;EACE,sOAAsO;AACxO;AACA;EACE,+BAA+B;AACjC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,sBAAsB;EACtB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yEAAyE;AAC3E;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,qDAAqD;AACvD;AACA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;AACtB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".v-alert {\n  display: grid;\n  flex: 1 1;\n  grid-template-areas: \"prepend content append close\" \". content . .\";\n  grid-template-columns: max-content auto max-content max-content;\n  position: relative;\n  padding: 16px;\n  overflow: hidden;\n  --v-border-color: currentColor;\n}\n.v-alert--absolute {\n  position: absolute;\n}\n.v-alert--fixed {\n  position: fixed;\n}\n.v-alert--sticky {\n  position: sticky;\n}\n.v-alert {\n  border-radius: 4px;\n}\n.v-alert--variant-plain, .v-alert--variant-outlined, .v-alert--variant-text, .v-alert--variant-tonal {\n  background: transparent;\n  color: inherit;\n}\n.v-alert--variant-plain {\n  opacity: 0.62;\n}\n.v-alert--variant-plain:focus, .v-alert--variant-plain:hover {\n  opacity: 1;\n}\n.v-alert--variant-plain .v-alert__overlay {\n  display: none;\n}\n.v-alert--variant-elevated, .v-alert--variant-flat {\n  background: rgb(var(--v-theme-surface-light));\n  color: rgba(var(--v-theme-on-surface-light), var(--v-high-emphasis-opacity));\n}\n.v-alert--variant-elevated {\n  box-shadow: 0px 2px 1px -1px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 1px 1px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 3px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-alert--variant-flat {\n  box-shadow: 0px 0px 0px 0px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 0px 0px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 0px 0px 0px var(--v-shadow-key-ambient-opacity, rgba(0, 0, 0, 0.12));\n}\n.v-alert--variant-outlined {\n  border: thin solid currentColor;\n}\n.v-alert--variant-text .v-alert__overlay {\n  background: currentColor;\n}\n.v-alert--variant-tonal .v-alert__underlay {\n  background: currentColor;\n  opacity: var(--v-activated-opacity);\n  border-radius: inherit;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  pointer-events: none;\n}\n.v-alert .v-alert__underlay {\n  position: absolute;\n}\n.v-alert--prominent {\n  grid-template-areas: \"prepend content append close\" \"prepend content . .\";\n}\n.v-alert.v-alert--border {\n  --v-border-opacity: 0.38;\n}\n.v-alert.v-alert--border.v-alert--border-start {\n  padding-inline-start: 24px;\n}\n.v-alert.v-alert--border.v-alert--border-end {\n  padding-inline-end: 24px;\n}\n.v-alert--variant-plain {\n  transition: 0.2s opacity cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-alert--density-default {\n  padding-bottom: 16px;\n  padding-top: 16px;\n}\n.v-alert--density-default.v-alert--border-top {\n  padding-top: 24px;\n}\n.v-alert--density-default.v-alert--border-bottom {\n  padding-bottom: 24px;\n}\n\n.v-alert--density-comfortable {\n  padding-bottom: 12px;\n  padding-top: 12px;\n}\n.v-alert--density-comfortable.v-alert--border-top {\n  padding-top: 20px;\n}\n.v-alert--density-comfortable.v-alert--border-bottom {\n  padding-bottom: 20px;\n}\n\n.v-alert--density-compact {\n  padding-bottom: 8px;\n  padding-top: 8px;\n}\n.v-alert--density-compact.v-alert--border-top {\n  padding-top: 16px;\n}\n.v-alert--density-compact.v-alert--border-bottom {\n  padding-bottom: 16px;\n}\n\n.v-alert:not(:has(.v-alert-title)) .v-alert__content {\n  padding-block: calc((1.75rem - 1.5 * 1rem) / 2);\n}\n\n.v-alert__border {\n  border-radius: inherit;\n  bottom: 0;\n  left: 0;\n  opacity: var(--v-border-opacity);\n  position: absolute;\n  pointer-events: none;\n  right: 0;\n  top: 0;\n  width: 100%;\n}\n.v-alert__border {\n  border-color: currentColor;\n  border-style: solid;\n  border-width: 0;\n}\n.v-alert__border--border {\n  border-width: 8px;\n  box-shadow: none;\n}\n.v-alert--border-start .v-alert__border {\n  border-inline-start-width: 8px;\n}\n.v-alert--border-end .v-alert__border {\n  border-inline-end-width: 8px;\n}\n.v-alert--border-top .v-alert__border {\n  border-top-width: 8px;\n}\n.v-alert--border-bottom .v-alert__border {\n  border-bottom-width: 8px;\n}\n\n.v-alert__close {\n  flex: 0 1 auto;\n  grid-area: close;\n}\n.v-alert__close > .v-btn {\n  margin-block: calc(-1 * (var(--v-btn-height) + 12px - 1.75rem) / 2);\n}\n\n.v-alert__content {\n  align-self: center;\n  grid-area: content;\n  overflow: hidden;\n}\n\n.v-alert__append,\n.v-alert__close {\n  margin-inline-start: 16px;\n}\n\n.v-alert__append {\n  align-self: flex-start;\n  grid-area: append;\n}\n.v-alert__append + .v-alert__close {\n  margin-inline-start: 16px;\n}\n\n.v-alert__prepend {\n  align-self: flex-start;\n  display: flex;\n  align-items: center;\n  grid-area: prepend;\n  margin-inline-end: 16px;\n  min-height: 1.75rem;\n}\n.v-alert__prepend > .v-icon {\n  font-size: 1.75rem;\n  height: 1.75rem;\n  width: 1.75rem;\n}\n.v-alert--prominent .v-alert__prepend {\n  align-self: center;\n}\n\n.v-alert__underlay {\n  grid-area: none;\n  position: absolute;\n}\n.v-alert--border-start .v-alert__underlay {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.v-alert--border-end .v-alert__underlay {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.v-alert--border-top .v-alert__underlay {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.v-alert--border-bottom .v-alert__underlay {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.v-alert-title {\n  align-items: center;\n  align-self: center;\n  display: flex;\n  font-size: 1.25rem;\n  font-weight: 500;\n  hyphens: auto;\n  letter-spacing: 0.0125em;\n  line-height: 1.75rem;\n  overflow-wrap: normal;\n  text-transform: none;\n  word-break: normal;\n  word-wrap: break-word;\n}\n\n@media (forced-colors: active) {\n  .v-alert:not(.v-alert--variant-text, .v-alert--variant-plain) {\n    border-style: solid;\n  }\n  .v-alert--variant-outlined, .v-alert--variant-tonal {\n    border-width: medium;\n  }\n  .v-alert--variant-elevated, .v-alert--variant-flat {\n    border-width: thick;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
